import { useState } from 'react';
import cvData from '../data/cv-data.json';

// Define types matching the structure in pdf-parser.ts
export interface Experience {
  title: string;
  company: string;
  period: string;
  description: string[];
}

export interface Skill {
  name: string;
  level: number;
}

export interface SkillCategory {
  id: string;
  name: string;
  skills: Skill[];
}

export interface Project {
  title: string;
  description: string;
  technologies: string[];
  github?: string;
  demo?: string;
}

export interface CVData {
  name: string;
  title: string;
  summary: string;
  experiences: Experience[];
  skillCategories: SkillCategory[];
  projects: Project[];
  contact: {
    email: string;
    linkedin?: string;
    github?: string;
    phone?: string;
  };
}

export function useCV() {
  const [data] = useState<CVData>(cvData as CVData);
  
  return {
    data,
    experiences: data.experiences,
    skillCategories: data.skillCategories,
    projects: data.projects,
    contact: data.contact,
    summary: data.summary,
    name: data.name,
    title: data.title
  };
} 